import { render } from "./RedirectPopup.vue?vue&type=template&id=c57594e2&ts=true"
import script from "./RedirectPopup.vue?vue&type=script&lang=ts"
export * from "./RedirectPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__